<template>
  <router-view name="coupon" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Coupon",
};
</script>
